import React from "react";
import { motion } from "framer-motion";
import { useAuth } from "../contexts/AuthContext";
import { Redirect } from "react-router-dom";

const HomeVariants = {
  hidden: {
    x: "100vw",
    opacity: 0.1,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: { duration: 0.2 },
  },
  exit: {
    x: "-100vw",
    transition: { ease: "easeInOut" },
  },
};

const Home = ({ containerMinHeight }) => {
  const { currentUser } = useAuth();

  if (currentUser !== null) return <Redirect to="/Dashboard" />;
  return (
    <>
      <motion.main
        style={{ minHeight: `calc(100vh - ${containerMinHeight}px)` }}
        className=" max-w-7xl mx-auto md:flex md:items-center md:justify-between justify-center overflow-hidden "
        variants={HomeVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        {/*Heading & texts*/}
        <motion.div
          className="md:px-8 mb-5 md:mb-0 md:p-0 sm:p-4 p-4 md:w-1/2 space-y-5 flex flex-col"
          initial={{ x: "-100vw" }}
          animate={{ x: 0 }}
          transition={{ delay: 0.6, type: "spring", stiffness: 120 }}
        >
          <h1 className="md:text-6xl sm:text-5xl text-4xl font-extrabold md:self-start self-center text-gray-900 leading-relaxed">
            <span className="text-blue-700 font-black">M</span>Pocket
          </h1>

          <h2 className="text-gray-600 md:text-lg font-medium leading-relaxed">
            True wealth is built when you spend less than you make, and to do
            that, you need to be aware of your spending and curb or eliminate
            expenses that are blowing your budget.
          </h2>

          <div className="md:pt-5 py-4 md:self-start self-center flex space-x-4">
            <motion.button
              className="focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50 s bg-blue-700 shadow-md md:text-sm text-sm font-medium uppercase tracking-normal lg:px-8 md:px-4 md:py-4 px-5 py-3 rounded-md text-white"
              whileHover={{
                backgroundColor: "#2563EB",
              }}
            >
              start building your wealth
            </motion.button>
            <motion.button
              className=" focus:outline-none focus:ring-2 focus:ring-blue-600 focus:ring-opacity-50 text-blue-700 border-opacity-70 text-opacity-70 border-2 border-blue-700 md:text-sm text-sm font-normal uppercase tracking-normal md:px-6 md:py-4 px-5 py-3 rounded-md"
              whileHover={{
                color: "#2563EB",
                borderColor: "#2563EB",
              }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              Learn more
            </motion.button>
          </div>
        </motion.div>

        {/*Main image*/}
        <motion.div
          className="md:w-1/2"
          initial={{ x: "100vw" }}
          animate={{ x: 0 }}
          transition={{ delay: 0.3, type: "tween" }}
          whileHover={{ scale: 1.1 }}
        >
          <img
            src="./images/save.svg"
            alt="Saving Money"
            className="cursor-pointer"
          />
        </motion.div>

        {/*Services*/}
      </motion.main>
    </>
  );
};

export default Home;
